import styled from '@emotion/styled';
import type { LayoutPreset } from 'modules/manager/domain/layout-blocks';
import React from 'react';
import UDModal from 'ud-ui/components/modal';
import LayoutPresetCard from './layout-preset-card';

interface LayoutBlocksModalProps {
  show: boolean;
  onClose: () => void;
  presets: LayoutPreset[];
  currentPresetId?: string;
  onPick: (presetId: string) => void;
}

const LayoutBlocksModal: React.FC<LayoutBlocksModalProps> = ({
  show,
  onClose,
  presets,
  currentPresetId,
  onPick,
}) => (
  <UDModal show={show} onClose={onClose}>
    <Root>
      <Title>Choose layout</Title>
      <Grid>
        {presets.map((preset) => (
          <LayoutPresetCard
            key={preset.id}
            preset={preset}
            selected={preset.id === currentPresetId}
            onClick={() => {
              onPick(preset.id);
              onClose();
            }}
          />
        ))}
      </Grid>
    </Root>
  </UDModal>
);

export default React.memo(LayoutBlocksModal);

const Root = styled.div`
  width: min(720px, 90vw);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
